<!-- Parsec Cloud (https://parsec.cloud) Copyright (c) AGPL-3.0-only 2016-present Scille SAS -->

<template>
  <div>CUSTOM ORDER BILLING DETAILS</div>
</template>

<script setup lang="ts"></script>

<style scoped lang="scss"></style>
